export default __webpack_public_path__ + "static/ACaslonPro-Regular-56eeb98c975dc456e08d4de194a406dc.woff2";